import { NgModule, Optional, SkipSelf } from '@angular/core';
import { AuthModule } from '@auth0/auth0-angular';

import { environment } from 'src/environments/environment';

@NgModule({
  imports: [
    AuthModule.forRoot({
      domain: environment.CLIENT_AUTHORITY,
      clientId: environment.CLIENT_ID,
      authorizationParams: {
        redirect_uri: window.location.origin
      },
      cacheLocation: 'localstorage', 
    })
  ],
  
  providers: [
  ], // Add app-wide services here

  exports: [
    AuthModule
  ]
})

export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
    }
  }
}
